import Plugin, { init } from "@/modules/_utils/Plugin";
import $ from "jquery";
window.jQuery = $;

class CartStep extends Plugin {
  init() {
    const checkbox = document.querySelectorAll(
      'input[type=checkbox][name="delivery"]'
    );
    const invoice = document.querySelectorAll(
      'input[type=radio][name="invoiceType"]'
    );

    function invoiceHandler(e) {
      if (this.value === "personel") {
        $(".address__content-form_invoice-area .company__field").removeClass(
          "show__item--block"
        );
        $(".address__content-form_invoice-area .company__field").addClass(
          "hide__item--none"
        );
      } else {
        $(".address__content-form_invoice-area .company__field").removeClass(
          "hide__item--none"
        );
        $(".address__content-form_invoice-area .company__field").addClass(
          "show__item--block"
        );
      }
    }

    function changeHandler(e) {
      if (this.checked) {
        $(
          ".address__content-form_invoice-head, .address__content-form_invoice-area_field"
        ).hide();
      } else {
        $(
          ".address__content-form_invoice-head, .address__content-form_invoice-area_field"
        ).show();
      }
    }

    Array.prototype.forEach.call(invoice, function(invoiceTrigger) {
      invoiceTrigger.addEventListener("change", invoiceHandler);
    });

    Array.prototype.forEach.call(checkbox, function(checkTrigger) {
      checkTrigger.addEventListener("change", changeHandler);
    });

    $("span.down").on("click", function() {
      let downVal = parseInt(
        $(this)
          .closest(".cart__detail-content_product-item_count-action")
          .find('input[type="number"]')
          .val()
      );
      if (downVal < 1) {
        $(this)
          .closest(".cart__detail-content_product-item_count-action")
          .find('input[type="number"]')
          .val(0);
      } else {
        $(this)
          .closest(".cart__detail-content_product-item_count-action")
          .find('input[type="number"]')
          .val(downVal - 1);
      }
    });

    $("span.up").on("click", function() {
      let upVal = parseInt(
        $(this)
          .closest(".cart__detail-content_product-item_count-action")
          .find('input[type="number"]')
          .val()
      );
      $(this)
        .closest(".cart__detail-content_product-item_count-action")
        .find('input[type="number"]')
        .val(upVal + 1);
    });
  }
}

export default init(CartStep, "cartStep");
